import { Injectable } from "@angular/core";
import { CanMatch, Router,  UrlTree } from "@angular/router";
import { PermissionCheckerService } from "./services/permission/permission-checker.service";

@Injectable({ providedIn: 'root' })
export class ClientGuard implements CanMatch {

  constructor(private router: Router, private permissionChecker : PermissionCheckerService) {}


  canMatch(): boolean | UrlTree {
    console.log("🔥 ClientGuard FIRED");

    // TODO NUC-269: module-level persona guard. No single catalog capability maps
    // to "the whole client product module" (the reference gates per-route via
    // data.capability). Left role-gated pending a routing restructure out of scope.
    if (this.permissionChecker.hasRoleClient()) {
      return true;
    }
    return this.router.createUrlTree(['/access-denied']);
  }

}